import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    beforeEnter: (to, from, next) => {
      const authUser = store.getters["auth/AUTHENTICATED"];
      if (authUser) {
        next({
          path: "/order_tracking",
        });
      } else {
        next();
      }
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "@/components/Auth/Login.vue"),
  },
  {
    path: "/signup",
    name: "signup",
    beforeEnter: (to, from, next) => {
      const authUser = store.getters["auth/AUTHENTICATED"];
      if (authUser) {
        next({
          path: "/order_tracking",
        });
      } else {
        next();
      }
    },
    component: () =>
      import("@/components/Auth/SignUp.vue"),
  },
  {
    path: "/layout",
    name: "layout",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "about" */ "@/components/Dashboard/Dashboard.vue"
      ),
    children: [
      {
        path: "/dashboard",
        name: "dashboard",

        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/Dashboard/Layout/Layout.vue"
          ),
      },
      {
        path: "/query_products",
        name: "query_products",

        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/Products/PurchaseOrder/QueryProducts.vue"
          ),
      },
      {
        path: "/catalogue_products",
        name: "catalogue_products",

        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/Products/Catologue/CatologueProducts.vue"
          ),
      },
      {
        path: "/details_products/:id",
        name: "details_products",

        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/Products/Catologue/Details.vue"
          ),
      },
      {
        path: "/technical_support/",
        name: "technical_support",

        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/Products/TechnicalSupport/TechnicalSupport.vue"
          ),
      },
      {
        path: "/news/",
        name: "news",

        component: () =>
          import(/* webpackChunkName: "about" */ "@/components/News/News.vue"),
      },
      {
        path: "/dropshipping",
        name: "dropshipping",
        // redirect: '/technical_support',

        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/Dropshipping/Index.vue"
          ),
      },
      {
        path: "/categories",
        name: "categories",
        // redirect: '/technical_support',

        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/Categories/Categories.vue"
          ),
      },
      {
        path: "/published_products",
        name: "published_products",
        // redirect: '/technical_support',

        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/Publications/Publication.vue"
          ),
      },
      {
        path: "/list_dropshipping",
        name: "list_dropshipping",
        // redirect: '/technical_support',

        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/components/Dropshipping/DropshippingSales.vue"
          ),
      },
      {
        path: "/product_catalog",
        name: "product_catalog",
        component: () =>
          import("@/components/Products/ProductCatalog/ProductCatalog.vue"),
      },
      {
        path: "/product_details",
        name: "product_details",
        component: () =>
          import("@/components/Products/ProductCatalog/ProductDetail.vue"),
        props: true,
      },
      {
        path: "/purchase_order",
        name: "purchase_order",
        component: () =>
          import("@/components/Products/PurchaseOrder/QueryProducts.vue"),
      },
      {
        path: "/details_order",
        name: "details_order",
        component: () =>
          import("@/components/Products/PurchaseOrder/DetailsOrder.vue"),
      },
      {
        path: "/order_tracking",
        name: "order_tracking",
        component: () =>
          import("@/components/Products/Tracking/OrderTracking.vue"),
      },
    ],
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "*",
    name: "not-found",
    // redirect: '/'
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Error.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// PROTECCION DE RUTAS
router.beforeEach((to, from, next) => {
  // CONSULTA USUARIO LOGUEADO
  const authUser = store.getters["auth/AUTHENTICATED"];

  // CREACION META
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!authUser) {
      next({
        path: "/",
      });
    } else {
      next();
      // LOGICA AQUI PROTECCION SEGUN EL ROL
    }
  } else {
    next();
  }
});

export default router;
